module.exports = __webpack_public_path__ + "static/img/14000482.ae5b4d53.png";